import React from 'react'
import styled from 'styled-components'
import Skeleton from 'components/_UI/Skeleton'
import DashboardEventCardSkeleton from './DashboardEventCardSkeleton'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'

export default function EventListSkeleton({ sections = [4, 3, 2] }) {
    return (
        <Container>
            {sections.map((cardCount, index) => (
                <SectionSkeleton key={index}>
                    <HeaderSkeleton>
                        <Skeleton
                            width="140px"
                            height="18px"
                        />
                    </HeaderSkeleton>
                    <CardsRow>
                        {Array.from({ length: cardCount }).map((_, i) => (
                            <DashboardEventCardSkeleton key={i} />
                        ))}
                    </CardsRow>
                </SectionSkeleton>
            ))}
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
`

const SectionSkeleton = styled.div`
    background: ${colors.neutralLight};
    padding: 15px;
    border-radius: 8px;
    width: 100%;

    @media screen and (min-width: ${breakpoints.sm}) {
        border-radius: 16px;
    }
`

const HeaderSkeleton = styled.div`
    padding: 15px 15px 0 15px;
    border-left: 3px solid ${colors.night}20;
    margin-left: 5px;
`

const CardsRow = styled.div`
    display: flex;
    padding: 10px;
    overflow: hidden;
`
